var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserNavigation'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm",staticStyle:{"padding-top":"10px"}},[_c('CartItemTable')],1)]),_c('div',{staticClass:"button-row"},[_c('button',{staticClass:"checkout-button",on:{"click":_vm.checkout}},[_vm._v("Naruči")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }